import { useState, useEffect } from 'react';
import initialMenuData from '../data/menu.json';
import { DataService } from '../services/dataService';

export const useRestaurantData = () => {
    const [data, setData] = useState(initialMenuData);

    useEffect(() => {
        const load = async () => {
            const result = await DataService.getAllData(initialMenuData);
            setData(result);
        };
        load();

        const handleStorageChange = (e) => {
            if (e.key === 'sugarhut_data' && e.newValue) {
                setData(JSON.parse(e.newValue));
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    return data;
};
